// extracted by mini-css-extract-plugin
export default {"container":"style_container__4mj2L","card":"style_card__tEXim"};